<template>
  <div>
    <b-button variant="link" @click="toggle = !toggle">
      <i class="material-icons material-icons-more-vert">
        more_vert
      </i>
    </b-button>
    <Popover :toggle="toggle" :isRelative="true">
      <div class="flex" @click="toggle = false">
        <slot></slot>
      </div>
    </Popover>
  </div>
</template>

<script>
import Popover from '@/components/Shared/Popover.vue'

const props = {
  horizontal: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  components: { Popover },
  data() {
    return {
      toggle: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';
.popover-wrapper {
  .tc-popover {
    min-width: 0 !important;
  }
}

.flex {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.material-icons-more-vert {
  color: map-get($theme-colors, 'black');
}
</style>
